import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './selectlink.css';
import '../../json/transparenciaItem';
import { transparencia_item } from '../../json/transparenciaItem';
const SelectLink = ({ label, options, defaultOption, linkPrefix }) => {
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const navigate = useNavigate();

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    navigate(linkPrefix + selectedValue);
  };

  return (
    <>
    {/* <label>{label}</label> */}
     {/* { <select id='select-link' value={selectedOption} onChange={handleOptionChange}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select> } */}

    { 
    <div className="dropdown">
    <button className="btn btn-success dropdown-toggle"  type="button" id="select-link" data-bs-toggle="dropdown" aria-expanded="false">
      {label}
    </button>
    <ul className="dropdown-menu"  aria-labelledby="select-link">
    {options.map((option) => (
        <li><a className="dropdown-item" href={option.value} value={option.value}>
          {option.label}
        </a></li>
      ))}
    </ul>
  </div>
    }

    </>
   
  );
};

export default SelectLink;
